const _excluded = ["children"],
  _excluded2 = ["thumbnails", "toolbar"];
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from 'react';
import { useLightboxProps, composePrefix, createIcon, ImageSlide, isImageSlide, cssClass, makeComposePrefix, useDocumentContext, useEventCallback, cssVar, clsx, getSlideKey, useRTL, useEvents, useLightboxState, useSensors, useKeyboardNavigation, useAnimation, cleanup, calculatePreload, hasSlides, getSlide, makeUseContext, LightboxPropsProvider, createIconDisabled, IconButton, addToolbarButton, createModule } from '../../index.js';
import { PLUGIN_THUMBNAILS, ELEMENT_ICON, CLASS_FLEX_CENTER, ACTION_SWIPE, ACTION_NEXT, ACTION_PREV, PLUGIN_FULLSCREEN, MODULE_CONTROLLER } from '../../types.js';
const defaultThumbnailsProps = {
  ref: null,
  position: "bottom",
  width: 120,
  height: 80,
  border: 1,
  borderRadius: 4,
  padding: 4,
  gap: 16,
  imageFit: "contain",
  vignette: true,
  hidden: false,
  showToggle: false
};
const resolveThumbnailsProps = thumbnails => _objectSpread(_objectSpread({}, defaultThumbnailsProps), thumbnails);
function useThumbnailsProps() {
  const _useLightboxProps = useLightboxProps(),
    thumbnails = _useLightboxProps.thumbnails;
  return resolveThumbnailsProps(thumbnails);
}
const cssPrefix = value => composePrefix(PLUGIN_THUMBNAILS, value);
const cssThumbnailPrefix = value => cssPrefix(composePrefix("thumbnail", value));
const VideoThumbnailIcon = createIcon("VideoThumbnail", /*#__PURE__*/React.createElement("path", {
  d: "M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
}));
const UnknownThumbnailIcon = createIcon("UnknownThumbnail", /*#__PURE__*/React.createElement("path", {
  d: "M23 18V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zM8.5 12.5l2.5 3.01L14.5 11l4.5 6H5l3.5-4.5z"
}));
function renderThumbnail(_ref) {
  let slide = _ref.slide,
    render = _ref.render,
    rect = _ref.rect,
    imageFit = _ref.imageFit;
  var _a;
  const customThumbnail = (_a = render.thumbnail) === null || _a === void 0 ? void 0 : _a.call(render, {
    slide,
    render,
    rect,
    imageFit
  });
  if (customThumbnail) {
    return customThumbnail;
  }
  const imageSlideProps = {
    render,
    rect,
    imageFit
  };
  if (slide.thumbnail) {
    return /*#__PURE__*/React.createElement(ImageSlide, _objectSpread({
      slide: {
        src: slide.thumbnail
      }
    }, imageSlideProps));
  }
  if (isImageSlide(slide)) {
    return /*#__PURE__*/React.createElement(ImageSlide, _objectSpread({
      slide: slide
    }, imageSlideProps));
  }
  const thumbnailIconClass = cssClass(cssThumbnailPrefix(ELEMENT_ICON));
  if (slide.type === "video") {
    return /*#__PURE__*/React.createElement(React.Fragment, null, slide.poster && /*#__PURE__*/React.createElement(ImageSlide, _objectSpread({
      slide: {
        src: slide.poster
      }
    }, imageSlideProps)), /*#__PURE__*/React.createElement(VideoThumbnailIcon, {
      className: thumbnailIconClass
    }));
  }
  return /*#__PURE__*/React.createElement(UnknownThumbnailIcon, {
    className: thumbnailIconClass
  });
}
const activePrefix = makeComposePrefix("active");
const fadeInPrefix = makeComposePrefix("fadein");
const fadeOutPrefix = makeComposePrefix("fadeout");
const placeholderPrefix = makeComposePrefix("placeholder");
const DELAY = "delay";
const DURATION = "duration";
function Thumbnail(_ref2) {
  let slide = _ref2.slide,
    onClick = _ref2.onClick,
    active = _ref2.active,
    fadeIn = _ref2.fadeIn,
    fadeOut = _ref2.fadeOut,
    placeholder = _ref2.placeholder,
    onLoseFocus = _ref2.onLoseFocus;
  const ref = React.useRef(null);
  const _useLightboxProps2 = useLightboxProps(),
    render = _useLightboxProps2.render,
    styles = _useLightboxProps2.styles;
  const _useDocumentContext = useDocumentContext(),
    getOwnerDocument = _useDocumentContext.getOwnerDocument;
  const _useThumbnailsProps = useThumbnailsProps(),
    width = _useThumbnailsProps.width,
    height = _useThumbnailsProps.height,
    imageFit = _useThumbnailsProps.imageFit;
  const rect = {
    width,
    height
  };
  const onLoseFocusCallback = useEventCallback(onLoseFocus);
  React.useEffect(() => {
    if (fadeOut && getOwnerDocument().activeElement === ref.current) {
      onLoseFocusCallback();
    }
  }, [fadeOut, onLoseFocusCallback, getOwnerDocument]);
  return /*#__PURE__*/React.createElement("button", {
    ref: ref,
    type: "button",
    className: clsx(cssClass(CLASS_FLEX_CENTER), cssClass(cssThumbnailPrefix()), active && cssClass(cssThumbnailPrefix(activePrefix())), fadeIn && cssClass(cssThumbnailPrefix(fadeInPrefix())), fadeOut && cssClass(cssThumbnailPrefix(fadeOutPrefix())), placeholder && cssClass(cssThumbnailPrefix(placeholderPrefix()))),
    style: _objectSpread(_objectSpread(_objectSpread({}, fadeIn ? {
      [cssVar(cssThumbnailPrefix(fadeInPrefix(DURATION)))]: `${fadeIn.duration}ms`,
      [cssVar(cssThumbnailPrefix(fadeInPrefix(DELAY)))]: `${fadeIn.delay}ms`
    } : null), fadeOut ? {
      [cssVar(cssThumbnailPrefix(fadeOutPrefix(DURATION)))]: `${fadeOut.duration}ms`,
      [cssVar(cssThumbnailPrefix(fadeOutPrefix(DELAY)))]: `${fadeOut.delay}ms`
    } : null), styles.thumbnail),
    onClick: onClick
  }, slide && renderThumbnail({
    slide,
    render,
    rect,
    imageFit
  }));
}
function isHorizontal(position) {
  return ["top", "bottom"].includes(position);
}
function boxSize(thumbnails, dimension) {
  return dimension + 2 * (thumbnails.border + thumbnails.padding) + thumbnails.gap;
}
function getThumbnailKey(slide) {
  const _ref3 = slide || {
      thumbnail: "placeholder"
    },
    thumbnail = _ref3.thumbnail,
    poster = _ref3.poster;
  return typeof thumbnail === "string" && thumbnail || typeof poster === "string" && poster || slide && getSlideKey(slide) || undefined;
}
function ThumbnailsTrack(_ref4) {
  let visible = _ref4.visible,
    containerRef = _ref4.containerRef;
  const track = React.useRef(null);
  const isRTL = useRTL();
  const _useEvents = useEvents(),
    publish = _useEvents.publish,
    subscribe = _useEvents.subscribe;
  const _useLightboxProps3 = useLightboxProps(),
    carousel = _useLightboxProps3.carousel,
    styles = _useLightboxProps3.styles;
  const _useLightboxState = useLightboxState(),
    slides = _useLightboxState.slides,
    globalIndex = _useLightboxState.globalIndex,
    animation = _useLightboxState.animation;
  const _useSensors = useSensors(),
    registerSensors = _useSensors.registerSensors,
    subscribeSensors = _useSensors.subscribeSensors;
  useKeyboardNavigation(subscribeSensors);
  const thumbnails = useThumbnailsProps();
  const position = thumbnails.position,
    width = thumbnails.width,
    height = thumbnails.height,
    border = thumbnails.border,
    borderStyle = thumbnails.borderStyle,
    borderColor = thumbnails.borderColor,
    borderRadius = thumbnails.borderRadius,
    padding = thumbnails.padding,
    gap = thumbnails.gap,
    vignette = thumbnails.vignette;
  const animationDuration = (animation === null || animation === void 0 ? void 0 : animation.duration) || 0;
  const offset = animationDuration > 0 && (animation === null || animation === void 0 ? void 0 : animation.increment) || 0;
  const _useAnimation = useAnimation(track, snapshot => ({
      keyframes: isHorizontal(position) ? [{
        transform: `translateX(${(isRTL ? -1 : 1) * boxSize(thumbnails, width) * offset + snapshot}px)`
      }, {
        transform: "translateX(0)"
      }] : [{
        transform: `translateY(${boxSize(thumbnails, height) * offset + snapshot}px)`
      }, {
        transform: "translateY(0)"
      }],
      duration: animationDuration,
      easing: animation === null || animation === void 0 ? void 0 : animation.easing
    })),
    prepareAnimation = _useAnimation.prepareAnimation;
  const handleControllerSwipe = useEventCallback(() => {
    let animationOffset = 0;
    if (containerRef.current && track.current) {
      const containerRect = containerRef.current.getBoundingClientRect();
      const trackRect = track.current.getBoundingClientRect();
      animationOffset = isHorizontal(position) ? trackRect.left - containerRect.left - (containerRect.width - trackRect.width) / 2 : trackRect.top - containerRect.top - (containerRect.height - trackRect.height) / 2;
    }
    prepareAnimation(animationOffset);
  });
  React.useEffect(() => cleanup(subscribe(ACTION_SWIPE, handleControllerSwipe)), [subscribe, handleControllerSwipe]);
  const preload = calculatePreload(carousel, slides);
  const items = [];
  if (hasSlides(slides)) {
    for (let index = globalIndex - preload - Math.abs(offset); index <= globalIndex + preload + Math.abs(offset); index += 1) {
      const placeholder = carousel.finite && (index < 0 || index > slides.length - 1) || offset < 0 && index < globalIndex - preload || offset > 0 && index > globalIndex + preload;
      const slide = !placeholder ? getSlide(slides, index) : null;
      const key = [`${index}`, getThumbnailKey(slide)].filter(Boolean).join("|");
      items.push({
        key,
        index,
        slide
      });
    }
  }
  const handleClick = slideIndex => () => {
    if (slideIndex > globalIndex) {
      publish(ACTION_NEXT, {
        count: slideIndex - globalIndex
      });
    } else if (slideIndex < globalIndex) {
      publish(ACTION_PREV, {
        count: globalIndex - slideIndex
      });
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(cssClass(cssPrefix("container")), cssClass(CLASS_FLEX_CENTER)),
    style: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, !visible ? {
      display: "none"
    } : null), width !== defaultThumbnailsProps.width ? {
      [cssVar(cssThumbnailPrefix("width"))]: `${width}px`
    } : null), height !== defaultThumbnailsProps.height ? {
      [cssVar(cssThumbnailPrefix("height"))]: `${height}px`
    } : null), border !== defaultThumbnailsProps.border ? {
      [cssVar(cssThumbnailPrefix("border"))]: `${border}px`
    } : null), borderStyle ? {
      [cssVar(cssThumbnailPrefix("border_style"))]: borderStyle
    } : null), borderColor ? {
      [cssVar(cssThumbnailPrefix("border_color"))]: borderColor
    } : null), borderRadius !== defaultThumbnailsProps.borderRadius ? {
      [cssVar(cssThumbnailPrefix("border_radius"))]: `${borderRadius}px`
    } : null), padding !== defaultThumbnailsProps.padding ? {
      [cssVar(cssThumbnailPrefix("padding"))]: `${padding}px`
    } : null), gap !== defaultThumbnailsProps.gap ? {
      [cssVar(cssThumbnailPrefix("gap"))]: `${gap}px`
    } : null), styles.thumbnailsContainer)
  }, /*#__PURE__*/React.createElement("nav", _objectSpread({
    ref: track,
    style: styles.thumbnailsTrack,
    className: clsx(cssClass(cssPrefix("track")), cssClass(CLASS_FLEX_CENTER)),
    tabIndex: -1
  }, registerSensors), items.map(_ref5 => {
    let key = _ref5.key,
      index = _ref5.index,
      slide = _ref5.slide;
    const fadeAnimationDuration = animationDuration / Math.abs(offset || 1);
    const fadeIn = offset > 0 && index > globalIndex + preload - offset && index <= globalIndex + preload || offset < 0 && index < globalIndex - preload - offset && index >= globalIndex - preload ? {
      duration: fadeAnimationDuration,
      delay: ((offset > 0 ? index - (globalIndex + preload - offset) : globalIndex - preload - offset - index) - 1) * fadeAnimationDuration
    } : undefined;
    const fadeOut = offset > 0 && index < globalIndex - preload || offset < 0 && index > globalIndex + preload ? {
      duration: fadeAnimationDuration,
      delay: (offset > 0 ? offset - (globalIndex - preload - index) : -offset - (index - (globalIndex + preload))) * fadeAnimationDuration
    } : undefined;
    return /*#__PURE__*/React.createElement(Thumbnail, {
      key: key,
      slide: slide,
      active: index === globalIndex,
      fadeIn: fadeIn,
      fadeOut: fadeOut,
      placeholder: !slide,
      onClick: handleClick(index),
      onLoseFocus: () => {
        var _a;
        return (_a = track.current) === null || _a === void 0 ? void 0 : _a.focus();
      }
    });
  })), vignette && /*#__PURE__*/React.createElement("div", {
    className: cssClass(cssPrefix("vignette"))
  }));
}
const ThumbnailsContext = /*#__PURE__*/React.createContext(null);
const useThumbnails = makeUseContext("useThumbnails", "ThumbnailsContext", ThumbnailsContext);
function ThumbnailsContextProvider(_ref6) {
  let children = _ref6.children,
    props = _objectWithoutProperties(_ref6, _excluded);
  const _resolveThumbnailsPro = resolveThumbnailsProps(props.thumbnails),
    ref = _resolveThumbnailsPro.ref,
    position = _resolveThumbnailsPro.position,
    hidden = _resolveThumbnailsPro.hidden;
  const _React$useState = React.useState(!hidden),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    visible = _React$useState2[0],
    setVisible = _React$useState2[1];
  const containerRef = React.useRef(null);
  const context = React.useMemo(() => ({
    visible,
    show: () => setVisible(true),
    hide: () => setVisible(false)
  }), [visible]);
  React.useImperativeHandle(ref, () => context, [context]);
  return /*#__PURE__*/React.createElement(LightboxPropsProvider, _objectSpread({}, props), /*#__PURE__*/React.createElement(ThumbnailsContext.Provider, {
    value: context
  }, /*#__PURE__*/React.createElement("div", {
    ref: containerRef,
    className: clsx(cssClass(cssPrefix()), cssClass(cssPrefix(`${position}`)))
  }, ["start", "top"].includes(position) && /*#__PURE__*/React.createElement(ThumbnailsTrack, {
    containerRef: containerRef,
    visible: visible
  }), /*#__PURE__*/React.createElement("div", {
    className: cssClass(cssPrefix("wrapper"))
  }, children), ["end", "bottom"].includes(position) && /*#__PURE__*/React.createElement(ThumbnailsTrack, {
    containerRef: containerRef,
    visible: visible
  }))));
}
const thumbnailsIcon = () => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  strokeWidth: 2,
  stroke: "currentColor",
  strokeLinejoin: "round",
  fill: "none",
  d: "M3 5l18 0l0 14l-18 0l0-14z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5 14h4v3h-4zM10 14h4v3h-4zM15 14h4v3h-4z"
})));
const ThumbnailsVisible = createIcon("ThumbnailsVisible", thumbnailsIcon());
const ThumbnailsHidden = createIconDisabled("ThumbnailsHidden", thumbnailsIcon());
function ThumbnailsButton() {
  const _useThumbnails = useThumbnails(),
    visible = _useThumbnails.visible,
    show = _useThumbnails.show,
    hide = _useThumbnails.hide;
  const _useLightboxProps4 = useLightboxProps(),
    render = _useLightboxProps4.render;
  if (render.buttonThumbnails) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, render.buttonThumbnails({
      visible,
      show,
      hide
    }));
  }
  return /*#__PURE__*/React.createElement(IconButton, {
    label: visible ? "Hide thumbnails" : "Show thumbnails",
    icon: visible ? ThumbnailsVisible : ThumbnailsHidden,
    renderIcon: visible ? render.iconThumbnailsVisible : render.iconThumbnailsHidden,
    onClick: visible ? hide : show
  });
}
function Thumbnails(_ref7) {
  let augment = _ref7.augment,
    contains = _ref7.contains,
    append = _ref7.append,
    addParent = _ref7.addParent;
  augment(_ref8 => {
    let thumbnailsProps = _ref8.thumbnails,
      toolbar = _ref8.toolbar,
      restProps = _objectWithoutProperties(_ref8, _excluded2);
    const thumbnails = resolveThumbnailsProps(thumbnailsProps);
    return _objectSpread({
      toolbar: addToolbarButton(toolbar, PLUGIN_THUMBNAILS, thumbnails.showToggle ? /*#__PURE__*/React.createElement(ThumbnailsButton, null) : null),
      thumbnails
    }, restProps);
  });
  const module = createModule(PLUGIN_THUMBNAILS, ThumbnailsContextProvider);
  if (contains(PLUGIN_FULLSCREEN)) {
    append(PLUGIN_FULLSCREEN, module);
  } else {
    addParent(MODULE_CONTROLLER, module);
  }
}
export { Thumbnails as default };